import styled from 'styled-components';
import query from 'syf-component-library/const/mediaQueries';
import { fontSizes, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import { MessageBox } from 'syf-component-library/ui/patterns';
import { Body, H5 } from 'syf-component-library/ui/typography';
export const MessageBoxTitle = styled(H5) `
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.root}px;
  line-height: ${fontSizes.large}px;
  margin-bottom: ${spacing.xsmall}px;
`;
export const MessageBoxContainer = styled(MessageBox) `
  padding: ${spacing.base}px;
  border-width: 2px;
  border-color: #34657f;
  background-color: #ebf7ff;
  margin: 0px ${spacing.base}px;
  svg {
    width: 24px;
    height: 24px;
    color: #34657f;
  }

  @media ${query.greaterThanMedium} {
    margin: 0px;
  }
`;
export const MessageBoxContent = styled.div `
  text-align: start;
  display: flex;
  align-items: start;
  flex-direction: column;
`;
export const MessageBoxDescription = styled(Body) `
  font-size: ${fontSizes.root}px;
  line-height: ${fontSizes.large}px;
`;
